import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/public/public.routes').then(m => m.routes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.routes)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/home/home.routes').then(m => m.routes)
  },
  {
    path: 'games',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/games/games.routes').then(m => m.routes)
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/users/users.routes').then(m => m.routes)
  },
  {
    path: 'lifequality',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/lifequality/lifequality.routes').then(m => m.routes)
  },
  {
    path: '**',
    redirectTo: 'home/ble-init'
  }
];
